export default {
  labelHelp: 'Sélectionnez une date avec le curseur',
  labelNoDateSelected: 'Aucune date',
  labelResetButton: 'Effacer',
  labelSelected: 'Date selectionnée',
  labelTodayButton: 'Aujourd\'hui',
}
